import { DEFAULT_RESOURCE_TYPE } from '@/utils/constants'
import http from '@/utils/http'

export const loadPlugins = (nodeID, type = DEFAULT_RESOURCE_TYPE) => http.get(`/kuiper/${nodeID}/plugins/${type}`)

export const loadAvailablePlugins = (nodeID, type = DEFAULT_RESOURCE_TYPE) =>
  http.get(`/kuiper/${nodeID}/plugins/${type}/prebuild`)

export const createPlugin = (nodeID, body = {}, type = DEFAULT_RESOURCE_TYPE) =>
  http.post(`/kuiper/${nodeID}/plugins/${type}`, body)

export const viewPlugin = (nodeID, id, type = DEFAULT_RESOURCE_TYPE) =>
  http.get(`/kuiper/${nodeID}/plugins/${type}/${id}`)

export const deletePlugin = (nodeID, id, type = DEFAULT_RESOURCE_TYPE) =>
  http.delete(`/kuiper/${nodeID}/plugins/${type}/${id}`)

export const registerFunc = (nodeID, name, body = {}) =>
  http.post(`/kuiper/${nodeID}/plugins/functions/${name}/register`, body)

export default {}
